export default __webpack_public_path__ + "static/media/subham.0f072eb8.png";